/**
 * Created by Mikhail Menshenin on 19.08.2024
 */

const CoinSlotMachineReel = function (index) {
    cleverapps.EventEmitter.call(this);

    this.symbols = CoinSlotMachineReel.SYMBOLS.map(function (symbol, index) {
        return new CoinSlotMachineSymbol(this, symbol, index);
    }, this);
    this.current = 0;
    this.index = index;

    this.setCurrentByType(PseudoRandom.GET().choose(CoinSlotMachineReel.SYMBOLS).type);
};

CoinSlotMachineReel.prototype = Object.create(cleverapps.EventEmitter.prototype);
CoinSlotMachineReel.prototype.constructor = CoinSlotMachineReel;

CoinSlotMachineReel.prototype.setCurrentByType = function (type) {
    this.current = this.symbols.filter((symbol) => symbol.type === type)[0].index;

    for (let i = 0; i < this.symbols.length; i++) {
        this.symbols[i].move();
    }
};

CoinSlotMachineReel.prototype.getCurrent = function () {
    return this.symbols[this.current];
};

CoinSlotMachineReel.prototype.spin = function (type, reelSpinCount, callback) {
    this.getCurrent().reset();

    this.minSpinsAmount = PseudoRandom.GET().random(20, 25);
    this._spinOneDegree(0, type, reelSpinCount, callback);
};

CoinSlotMachineReel.prototype._spinOneDegree = function (spins, type, reelSpinCount, callback) {
    spins++;
    this.current = (this.current - 1 + this.symbols.length) % this.symbols.length;

    let duration = CoinSlotMachineReel.ONE_DEGREE_DURATION * 3;
    let isFast = false;
    if (spins > 2) {
        duration = CoinSlotMachineReel.ONE_DEGREE_DURATION;
        isFast = true;
    }

    if (spins === reelSpinCount + this.index - CoinSlotMachineReel.SYMBOLS.length) {
        this.setCurrentByType(type);
    }

    if (spins >= reelSpinCount - 2) {
        duration = CoinSlotMachineReel.ONE_DEGREE_DURATION * 3;
        isFast = false;
    }

    const isLast = spins === reelSpinCount + this.index;

    for (let i = 0; i < this.symbols.length; i++) {
        this.symbols[i].spin(duration, isFast, isLast);
    }

    aisensia.slotMachine.counter.setTimeout(() => {
        if (isLast) {
            callback();
        } else {
            this._spinOneDegree(spins, type, reelSpinCount, callback);
        }
    }, duration);
};

CoinSlotMachineReel.ONE_DEGREE_DURATION = 50;
